import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }

import Card from 'primevue/card';

import CustomerProfileForm from '../components/CustomerProfileForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'NewClientView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "h-max flex-1 basis-[354px] border border-gray-200 !shadow-none" }, {
    content: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(CustomerProfileForm)
      ])), [
        [_directive_auto_animate]
      ])
    ]),
    _: 1
  }))
}
}

})